import {
  customQueryClient,
  QueryClientProvider,
} from '@ferreri/minato-react-utils';
import { angeplus } from '@ferreri/prever-component-lib';
import { AppLayout } from '@ferreri/prever-component-lib/nextjs';
import { AppProps } from 'next/app';
import { Encode_Sans } from 'next/font/google';

import { SETTINGS } from '../config/settings';
import { PAGE_TITLE } from '../utils/pageTitle';

const encodeSans = Encode_Sans({
  subsets: ['latin'],
  weight: [
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '700',
    '800',
    '900',
  ],
  variable: '--font-family-01',
});

// This default export is required in a new `pages/_app.js` file.
export default function MyApp({ Component, pageProps }: AppProps) {
  return (
    <QueryClientProvider client={customQueryClient}>
      <AppLayout
        theme={angeplus}
        productName="Angeplus"
        projectName="Chat"
        tmsToken={SETTINGS.public.tmsToken}
        fontFamily={encodeSans.variable}
        defaultTitle={PAGE_TITLE.defaultTitle}
      >
        <Component {...pageProps} />
      </AppLayout>
    </QueryClientProvider>
  );
}
